import React, { useState, useEffect, useMemo } from 'react';
import { getFechamentExecutadoMesAnoByFechamentoId } from '@app/api/fechamento';
import TabelaExecutadoMesAno from '../Executado/tabelaExecutadoMesAno';
import { RegistroEsin204 } from '@app/api/esin204';
interface FechamentoModuloExecutadoTabelaProps {
    carregarTabela: boolean;
    ano: number;
    fechamentoId: string;
    meses: string[];
}

const FechamentoModuloExecutadoTabela = (props: FechamentoModuloExecutadoTabelaProps) => {

    const { carregarTabela, ano, fechamentoId, meses } = props
    const [result, setResult] = useState<RegistroEsin204[]>();
    const [carregarDadosTabela, setCarregarDadosTabela] = useState<RegistroEsin204[]>();

    useEffect(() => {
        if (carregarDadosTabela && carregarDadosTabela.length > 0) {
            setResult(carregarDadosTabela);
        }
    }, [carregarDadosTabela])

    useMemo(async () => {
        if (meses && meses.length) {
            let resultRegistroEsin204: RegistroEsin204[] = [];

            for (let index = 0; index < meses.length; index++) {
                const mes = meses[index];

                const data = await getFechamentExecutadoMesAnoByFechamentoId(fechamentoId, mes, ano);
                if (data) {
                    resultRegistroEsin204.push(...data);
                }
            }
            setCarregarDadosTabela(resultRegistroEsin204);
        }
    }, [carregarTabela]);


    return (

        <>
            {result && result.length > 0 ? (
                <>
                    <TabelaExecutadoMesAno
                        result={result}
                        tabelaId={ano.toString()}
                    />
                </>) :
                (
                    <> </>
                )
            }
        </>
    );

}

export default FechamentoModuloExecutadoTabela;

